import { isEmptyObject } from './common'
import { GLOBAL_REGION, GLOBAL_BRAND } from './constants'

// Filter routers by regionName and brandName 
export function filterRouterMap(data, regionName, brandName) {
    // Validate if regionName and brandName exist
    let regionRouter = data[regionName]
    if (!regionRouter) {
        console.log("Region '%s' not found in router", brandName)
        return [];
    }
    let brandRouter = regionRouter[brandName]
    if (!brandRouter) {
        console.log("Brand '%s' not found in router region '%s'", brandName, regionName)
        return [];
    }
    // Return a deep copy of the router data
    let result = data[regionName][brandName]
    return JSON.parse(JSON.stringify(result))
}

export function assembleRouterList(routerMap, brandMap, region, brand) {
  console.log("Selected region '%s' brand '%s' for router filtering", region, brand)

  // Extract global routers
  const globalRouterList = filterRouterMap(routerMap, GLOBAL_REGION, GLOBAL_BRAND)
  // console.debug("Filter global router map by region '%s' brand '%s'", GLOBAL_REGION, GLOBAL_BRAND, globalRouterList)

  if (globalRouterList.length === 0) {
    console.log('Global router is empty')
  }

  // If user has no region and brand related permission, brandMap will be empty
  if (isEmptyObject(brandMap)) {
    return globalRouterList
  }

  // Extract routers by selected region and brand
  const brandRouterList = filterRouterMap(routerMap, region, brand)

  // TODO brandRouterList content is still obsolete
  // console.debug("Filter region&brand router map by region '%s' brand '%s'", region, brand, brandRouterList)

  // Combine global and region&brand related routers
  const routerList = globalRouterList.concat(brandRouterList)
  routerList.sort((a, b) => a.order - b.order)

  return routerList
}
